import React, { useEffect, useState } from 'react'
import './App.css'
import { Link, Redirect, useLocation, useHistory } from 'react-router-dom'
import Axios from 'axios'
import { IoIosArrowBack } from 'react-icons/io'
import Header2 from './components/Header2'
import Header3 from './components/Header3'
import Header5 from './components/Header5'
import ClipLoader from 'react-spinners/ClipLoader'
import ReactTooltip from 'react-tooltip'
import SideNavCust from './layouts/SideNavCust'
import { BiMenu } from 'react-icons/bi'
import Header from './layouts/Header'
import { API_URL } from './config'

const TicketRefund = () => {
  const history = useHistory()
  const [successError, setSuccessError] = useState()
  const [errorDisplay, setErrorDisplay] = useState()
  const [error, setError] = useState()
  const [feedback, setFeedback] = useState()
  const [acknowledge, setAcknowledge] = useState(false)
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(false)
  const [subLoading, setSubLoading] = useState(false)
  const [saveBtn, setSaveBtn] = useState('warning-btn')
  const [saveSubBtn, setSaveSubBtn] = useState('save-btn')
  const [subDisabled, setSubDisabled] = useState(false)

  const isMobile = window.innerWidth <= 768
  const [isMob, setIsMob] = useState()
  const [collapsed, setCollapsed] = useState(isMobile)

  const location = useLocation()
  //   const navigate = useNavigate();
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`
  const {
    ticket_id,
    ticket_number,
    event_name,
    event_id,
    refund_status,
    m_payment_id,
    refund_attempts,
    maxAttempts,
  } = location.state || {}

  const [refundReason, setRefundReason] = useState('')
  const [userNotes, setUserNotes] = useState('')
  const [statusMessage, setStatusMessage] = useState('')
  const [daysLeft, setDaysLeft] = useState(0)
  const [amountRefunded, setAmountRefunded] = useState(0)
  const [originalAmount, setOriginalAmount] = useState(0)
  const [bookingFee, setBookingFee] = useState(0)
  const [netAmount, setNetAmount] = useState(0)
  const [refundFee, setRefundFee] = useState(0)
  const [admission, setAdmission] = useState(0)
  const [refundStatus, setRefundStatus] = useState(refund_status)
  const [refundRulesConfigured, setRefundRulesConfigured] = useState(0)
  const [calLoading, setCalLoading] = useState(true)

  const customer_id = localStorage.getItem('customerid')

  const updateIsMobile = () => {
    const mobile = window.innerWidth <= 768
    setIsMob(mobile)
    setCollapsed((prev) => (mobile ? true : prev))
  }

  useEffect(() => {
    document.title = `${event_name || 'Ticket'} - Refund Request`

    Axios.get(
      `${baseURL}?query=CALCULATE-REFUND&event_id=${event_id}&ticket_id=${ticket_id}&ticket_number=${ticket_number}&customer_id=${customer_id}&m_payment_id=${m_payment_id}`,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setDaysLeft(response.data.days_left)
        setRefundFee(response.data.refund_fee)
        setAmountRefunded(response.data.amount_refunded)
        setAdmission(response.data.admission)
        setOriginalAmount(response.data.orginal_amount)
        setBookingFee(response.data.booking_fee)
        setNetAmount(response.data.net_amount)
        setRefundRulesConfigured(response.data.refundRulesConfigured)

        setTimeout(() => {
          setCalLoading(false)
        }, 1000)
      })
      .catch((error) => {
        console.log(error)
      })

    updateIsMobile()
    window.addEventListener('resize', updateIsMobile)

    return () => {
      // this runs on unmount
      window.removeEventListener('resize', updateIsMobile)
    }
  }, [event_name, count]) // empty dependency array = run once on mount

  const handleSubmit = (request) => {
    if (refundReason.trim() === '' && refundStatus !== 'Pending') {
      setErrorDisplay('block')
      setError('Please provide a reason for your refund request.')
      setSuccessError('error-login')

      setTimeout(() => {
        setErrorDisplay('none')
      }, 5000)
      return
    }

    if (request === 'cancel_request') {
      setSaveBtn('btn-disabled')
      setDisabled(true)
      setLoading(true)
    } else {
      setSaveSubBtn('btn-disabled')
      setSubDisabled(true)
      setSubLoading(true)
    }

    const formData = new FormData()
    formData.append('ticket_id', ticket_id)
    formData.append('ticket_number', ticket_number)
    formData.append('refund_reason', refundReason)
    formData.append('userNotes', userNotes)
    formData.append('customer_id', customer_id)
    formData.append('event_id', event_id)
    formData.append('refund_status', refundStatus)
    formData.append('m_payment_id', m_payment_id)

    formData.append('refundFee', refundFee)
    formData.append('daysLeft', daysLeft)
    formData.append('bookingFee', bookingFee)
    formData.append('estimatedRefund', amountRefunded)
    formData.append('originalAmount', originalAmount)
    formData.append('query', 'REQUEST-TICKET-REFUND')

    try {
      Axios({
        url: baseURL,
        method: 'POST',
        data: formData,
        withCredentials: true,
      }).then((response) => {
        setErrorDisplay('block')
        if (response.data.status === 'success') {
          setError(response.data.message)
          setSuccessError('success-login')
          if (refundStatus === 'Pending') {
            setRefundStatus('Cancelled')
          }
          // else {
          //   setRefundStatus("Pending");
          //   setSaveBtn("warning-btn");
          // }
          setCount(count + 1)

          // setSaveBtn("warning-btn");
          // setDisabled(false);
          setLoading(false)

          // setSaveSubBtn("save-btn");
          // setSubDisabled(false);
          setSubLoading(false)
          setAcknowledge(false)
        } else {
          if (response.data.code === 'BANK_DETAILS_NOT_FOUND') {
            setTimeout(() => {
              history.push({
                pathname: '/b-details',
                state: {
                  responseMessage: response.data.message,
                  responseCode: response.data.code,
                  bankList: response.data.bank_name,
                },
              })
            }, 4000)
          }
          setSaveBtn('warning-btn')
          setDisabled(false)
          setLoading(false)

          setSaveSubBtn('save-btn')
          setSubDisabled(false)
          setSubLoading(false)

          setError(<label className="mb-0">{response.data.message}</label>)
          setSuccessError('error-login')
        }

        setTimeout(() => {
          setErrorDisplay('none')
        }, 5000)
        // console.log(response.data);
      })
    } catch (error) {
      setError(error)
      setErrorDisplay('block')
      setSuccessError('error-login')
      setSaveBtn('warning-btn')
      setDisabled(false)
      setLoading(false)

      setSaveSubBtn('save-btn')
      setSubDisabled(false)
      setSubLoading(false)
    }
  }

  const handleReasonChange = (e) => {
    const selected = e.target.value
    setRefundReason(selected)
  }

  const handleNotesChange = (e) => {
    const noteText = e.target.value
    setUserNotes(noteText)
  }

  const handleAcknowledge = () => {
    if (acknowledge) {
      setAcknowledge(false)
    } else {
      setAcknowledge(true)
    }
  }

  let { accountname, dashboard } = ''
  if (localStorage.getItem('customername') === null) {
    if (localStorage.getItem('businessname') === null) {
      if (localStorage.getItem('partnername') === null) {
        return <Redirect to="/login" />
      } else {
        accountname = localStorage.getItem('partnername')
        dashboard = 'in'
      }
    } else {
      accountname = localStorage.getItem('businessname')
      dashboard = 'dashboard'
    }
  } else {
    accountname = localStorage.getItem('customername')
    dashboard = 'customerdashboard'
  }
  const customername = accountname

  const handleToggle = () => {
    setCollapsed((prev) => !prev)
  }

  return (
    <div className="view">
      <Header />
      <SideNavCust collapsed={collapsed} onToggle={handleToggle} />
      <div
        className="container"
        style={{
          marginTop: 40,
          marginLeft: isMob ? '0px' : collapsed ? 'auto' : 'auto',
        }}
      >
        {/* ✅ Mobile overlay when sidebar is open */}
        {isMobile && !collapsed && <div className="mobile-overlay active" onClick={handleToggle} />}

        {isMob && collapsed && (
          <label className="mobile-toggle" onClick={handleToggle}>
            <BiMenu size={25} />
          </label>
        )}
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search">
              <div className="row align-items-center justify-content-center">
                <div className="col-lg-4 col-6 pl-0">
                  <button type="button" onClick={() => history.goBack()} className="link-btn">
                    <IoIosArrowBack size={25} />
                    Back &nbsp;
                  </button>
                </div>

                <div
                  className={
                    refundStatus === 'Pending'
                      ? 'col-lg-8 col-6 text-right ticket-title pl-0 pr-0'
                      : 'd-none'
                  }
                >
                  <label className="w-100 ticket-title pl-0 pr-0">
                    <button
                      type="button"
                      className={saveBtn}
                      onClick={() => handleSubmit('cancel_request')}
                      disabled={disabled}
                    >
                      {!loading ? 'Cancel Request' : ''}
                      {loading ? <ClipLoader size={20} color={'#333'} loading={true} /> : ''}
                    </button>
                  </label>
                </div>

                <div
                  className={
                    refundStatus === 'Pending' ? 'd-none' : 'col-lg-8 col-6 text-right p-0'
                  }
                >
                  {/* <label className="back-arrow mb-0">
                    <button
                      type="button"
                      disabled={subDisabled}
                      className={
                        amountRefunded <= 0 || !acknowledge
                          ? "btn-disabled text-bold"
                          : saveSubBtn + " text-bold"
                      }
                      onClick={
                        amountRefunded <= 0
                          ? ""
                          : !acknowledge
                          ? () =>
                              alert(
                                "Please indicate if you acknowledge and understand the refund policy. Scroll to the bottom."
                              )
                          : () => handleSubmit("submit_request")
                      }
                    >
                      {!subLoading ? "Submit" : ""}
                      {subLoading ? (
                        <ClipLoader size={20} color={"#333"} loading={true} />
                      ) : (
                        ""
                      )}
                    </button>
                  </label> */}
                </div>
              </div>
            </div>
            {calLoading ? (
              <div className=" BoxDashboardContainer pl-2 pr-0 mb-5">
                <div className="row">
                  <div className="col-12 text-center">
                    <ClipLoader size={25} color="grey" />
                  </div>
                </div>
              </div>
            ) : (
              <div className=" BoxDashboardContainer pl-0 pr-0 mb-5">
                <div className="row align-self-center justify-content-center item-list">
                  <div className="col-lg-12">
                    <label className="ticket-title pl-0 pr-0">
                      REQUEST REFUND
                      <br />
                      <label className="note-line">
                        Ticket number: <span>{ticket_number}</span>
                      </label>
                    </label>
                  </div>

                  <div className="col-12 pr-0">
                    <div className="h-divider w-100"></div>
                  </div>
                </div>
                {amountRefunded <= 0 ? (
                  <div className="col-12">
                    <p className="refund-warning_">
                      Refunds are <span>not permitted on the day of the event</span>. This policy
                      helps ensure fairness to organisers and accounts for non-refundable
                      operational costs already committed. We appreciate your understanding and
                      encourage you to contact the organiser directly if exceptional circumstances
                      apply.
                    </p>
                  </div>
                ) : (
                  <>
                    <div className={refund_attempts === maxAttempts ? 'col-12' : 'd-none'}>
                      <label className="alert alert-warning p-2 mb-0">
                        You've reached the maximum of 3 refund attempts. No further requests
                        allowed.
                      </label>
                    </div>
                    <div className={refund_attempts === maxAttempts ? 'd-none' : 'w-100'}>
                      {refundStatus === 'Pending' ? (
                        <div className="col-12 pr-3">
                          <label className="mb-0 text-grey">
                            <span>Current status:</span> {refundStatus}
                          </label>
                          <br />
                          Your refund request is currently under review. We're processing it as
                          quickly as possible and will notify you once there's an update. If you'd
                          like to cancel this request, you're welcome to do so at any time.
                        </div>
                      ) : (
                        <>
                          <div className={'col-12 details-body mb-3'}>
                            <label htmlFor="reason">Reason for Refund:</label>
                            <br />
                            <select
                              value={refundReason}
                              onChange={handleReasonChange}
                              required
                              className="form-control"
                            >
                              <option value="">Select a reason</option>

                              <optgroup label="Event-Related">
                                <option value="event_cancelled">Event was cancelled</option>
                                <option value="event_rescheduled">Event was rescheduled</option>
                                <option value="performer_changed">
                                  Performer or headliner changed
                                </option>
                              </optgroup>

                              <optgroup label="Personal Circumstances">
                                <option value="cant_attend">I can't attend anymore</option>
                                <option value="wrong_ticket">I bought the wrong ticket type</option>
                                <option value="mistaken_purchase">
                                  I bought tickets by mistake
                                </option>
                              </optgroup>

                              <optgroup label="Technical Issues">
                                <option value="no_confirmation">
                                  Didn't receive ticket confirmation
                                </option>
                                <option value="duplicate_payment">
                                  Duplicate charge or booking
                                </option>
                                <option value="payment_error">Payment or booking issue</option>
                              </optgroup>

                              <option value="other">Other (please specify)</option>
                            </select>
                          </div>
                          <div className="col-12 details-body">
                            Additional Comments (optional):
                            <br />
                            <textarea
                              placeholder="Type here..."
                              onChange={handleNotesChange}
                              className="edit-input"
                            />
                          </div>
                          <div className="col-12 details-body">
                            <label className="alert alert-info p-2 small-text w-100 mt-3">
                              <h5>
                                <span>
                                  Refund Policy:{' '}
                                  {refundRulesConfigured === 'yes'
                                    ? "Organizer's Rules"
                                    : 'Karamale Default Rules'}
                                </span>
                              </h5>
                              <label
                                className={refundRulesConfigured === 'yes' ? 'd-none' : 'w-100'}
                              >
                                Refund requests submitted within 3 days of the event will incur a{' '}
                                <span className="text-12">R15 + 25%</span> processing fee and admin
                                cost or be declined per{' '}
                                <Link to={'/refund-policy'} target="_blank">
                                  Karamale refund policy.
                                </Link>
                                <br />
                                <br />
                              </label>
                              Original transaction:{' '}
                              <span className="text-12">R{originalAmount}</span>
                              <br />
                              Booking fee (non-refundable):{' '}
                              <span className="text-12">R{bookingFee}</span>{' '}
                              <span
                                className="font-normal p-2"
                                data-tip={`${
                                  refundRulesConfigured === 'yes'
                                    ? 'This fee helps the organizer cover event-related costs such as venue deposits or upfront expenses.'
                                    : 'This fee covers platform operations and payment processing.'
                                } ${
                                  refundRulesConfigured === 'yes'
                                    ? 'It is not refundable.'
                                    : 'It is retained by Karamale and is not refundable.'
                                } `}
                                data-effect="solid"
                                data-arrow-color="transparent"
                                data-type="dark"
                                data-place="top"
                              >
                                ℹ️
                                <ReactTooltip />
                              </span>
                              <br />
                              Refundable amount: <span className="text-12">R{netAmount}</span>{' '}
                              <br />
                              Refund request timing:{' '}
                              <span className="text-12">{daysLeft} days</span> before the event.
                              <br />
                              {refundRulesConfigured === 'no' ? 'Karamale' : 'Organizer'} refund
                              deduction: <span className="text-12">{refundFee}</span>
                              .<br />
                              Estimated refund: <span className="text-12">R{amountRefunded}</span>
                              .<br />
                              Admissions: <span className="text-12">{admission}</span>.
                            </label>
                          </div>
                          <div className="row">
                            {/* <div className="col-2 col-lg-1">
                              <input
                                type="checkbox"
                                className="w-auto h-auto"
                                id="checkbox"
                                onChange={handleAcknowledge}
                              />
                            </div> */}
                            <div className="col-12 col-lg-12">
                              <label
                                htmlFor="checkbox"
                                className="text-15 text-black cursor-pointer"
                              >
                                <input
                                  type="checkbox"
                                  className="w-auto h-auto"
                                  id="checkbox"
                                  onChange={handleAcknowledge}
                                />{' '}
                                I acknowledge and understand the information provided above.
                              </label>
                            </div>
                          </div>

                          <div className={'col-12 text-right details-body mb-0 mt-3'}>
                            <label className="back-arrow mb-0">
                              <button
                                type="button"
                                disabled={subDisabled}
                                className={
                                  amountRefunded <= 0 || !acknowledge
                                    ? 'btn-disabled text-bold'
                                    : saveSubBtn + ' text-bold'
                                }
                                onClick={
                                  amountRefunded <= 0
                                    ? ''
                                    : !acknowledge
                                    ? () =>
                                        alert(
                                          'Please indicate if you acknowledge and understand the refund policy. Scroll to the bottom.'
                                        )
                                    : () => handleSubmit('submit_request')
                                }
                              >
                                {!subLoading ? 'Submit' : ''}
                                {subLoading ? (
                                  <ClipLoader size={20} color={'#333'} loading={true} />
                                ) : (
                                  ''
                                )}
                              </button>
                            </label>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={successError} style={{ display: errorDisplay, textAlign: 'center' }}>
        {error}
      </div>
      {/* <Footer /> */}
    </div>
  )
}

export default TicketRefund
